import "core-js/modules/es.object.keys.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: ""
};
var _hoisted_2 = {
  class: "my-swiper-wrapper d-flex fl-a-c"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  class: "date-picker p-abs"
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1);

var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = {
  class: "calendar-cards-wrapper"
};
var _hoisted_8 = {
  key: 0,
  ref: "calendarCardsContainer",
  class: "calendar-cards"
};
var _hoisted_9 = {
  class: "grouping-hour"
};
var _hoisted_10 = {
  class: "cards-group"
};

var _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", {
  class: "tickets-group-separator"
}, null, -1);

var _hoisted_12 = {
  key: 1,
  class: "d-flex no-timeslots"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_swiper_slide = _resolveComponent("swiper-slide");

  var _component_el_date_picker = _resolveComponent("el-date-picker");

  var _component_el_button = _resolveComponent("el-button");

  var _component_swiper = _resolveComponent("swiper");

  var _component_Card = _resolveComponent("Card");

  var _component_el_config_provider = _resolveComponent("el-config-provider");

  return _openBlock(), _createBlock(_component_el_config_provider, {
    locale: _ctx.locale
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        key: "today-wrapper",
        class: _normalizeClass(["today-wrapper d-flex fl-j-c fl-a-c", {
          'selected-day': _ctx.areEqualDates(_ctx.todayDate, _ctx.selectedDate)
        }])
      }, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.areEqualDates(_ctx.todayDate, _ctx.selectedDate) ? _ctx.todayIcon : _ctx.todayIconBlack,
        iconAlt: "today",
        iconStyle: "width: 20px; height: 20px;",
        class: "today-icon"
      }, null, 8, ["iconContent"]), _createElementVNode("div", {
        class: "day-wrapper",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.getCards(_ctx.todayDate);
        })
      }, [_createElementVNode("p", null, _toDisplayString(_ctx.dayjs(_ctx.todayDate).format("ddd")), 1), _createElementVNode("strong", null, _toDisplayString(_ctx.dayjs(_ctx.todayDate).format("MMM") + " " + _ctx.todayDate.getDate()), 1)])], 2), _createVNode(_component_swiper, {
        modules: _ctx.modules,
        "slides-per-view": 7,
        "space-between": 10,
        "centered-slides": false,
        freeMode: true,
        navigation: true,
        virtual: "",
        ref: "swiper",
        onSwiper: _ctx.setSwiperRef
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFutureDates(_ctx.allDates), function (date, index) {
            return _openBlock(), _createBlock(_component_swiper_slide, {
              key: index,
              virtualIndex: index,
              class: _normalizeClass({
                'selected-day': _ctx.areEqualDates(date, _ctx.selectedDate)
              })
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("div", {
                  class: "day-wrapper",
                  onClick: function onClick($event) {
                    return _ctx.getCards(date);
                  }
                }, [_createElementVNode("p", null, _toDisplayString(_ctx.dayjs(date).format("ddd")), 1), _createElementVNode("strong", null, _toDisplayString(_ctx.dayjs(date).format("MMM") + " " + date.getDate()), 1)], 8, _hoisted_3)];
              }),
              _: 2
            }, 1032, ["virtualIndex", "class"]);
          }), 128)), _createVNode(_component_swiper_slide, null, {
            default: _withCtx(function () {
              return [_createElementVNode("div", null, [(_openBlock(), _createBlock(_component_el_button, {
                size: "large",
                type: "primary",
                icon: _ctx.Calendar,
                class: "f-bold p-rel load-more-calendar",
                onClick: _ctx.openCalendar,
                key: 'calendar-button-key',
                loading: _ctx.isFetchingFutureDate,
                style: {
                  "padding-left": "5px",
                  "padding-right": "5px"
                }
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("common.calendar")) + " ", 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_date_picker, {
                    modelValue: _ctx.selectedDate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return _ctx.selectedDate = $event;
                    }),
                    type: "date",
                    placeholder: "Pick a day",
                    ref: "datepicker",
                    onChange: _ctx.selectCustomDate,
                    "disabled-date": _ctx.isDateDisabled
                  }, null, 8, ["modelValue", "onChange", "disabled-date"])])];
                }),
                _: 1
              }, 8, ["icon", "onClick", "loading"]))])];
            }),
            _: 1
          }), (_openBlock(), _createBlock(_component_swiper_slide, {
            key: 'calendar-extra-key'
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          }))];
        }),
        _: 1
      }, 8, ["modules", "onSwiper"])]), _ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_ctx.cards ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.cards), function (key) {
        return _openBlock(), _createElementBlock("div", {
          key: key
        }, [_createElementVNode("p", _hoisted_9, _toDisplayString(key), 1), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards[key], function (card, index) {
          return _openBlock(), _createElementBlock("div", {
            onTouchmove: _cache[2] || (_cache[2] = //@ts-ignore
            function () {
              return _ctx.handleScroll && _ctx.handleScroll.apply(_ctx, arguments);
            }),
            onTouchstart: _cache[3] || (_cache[3] = //@ts-ignore
            function () {
              return _ctx.handleTouchStart && _ctx.handleTouchStart.apply(_ctx, arguments);
            }),
            key: index
          }, [_createVNode(_component_Card, {
            didScroll: _ctx.didScroll,
            product: card
          }, null, 8, ["didScroll", "product"])], 32);
        }), 128))]), _hoisted_11]);
      }), 128))], 512)) : _createCommentVNode("", true), !Object.keys(_ctx.cards).length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("calendar.no-timeslots")), 1), _createVNode(_component_SvgIcon, {
        iconContent: _ctx.infoIcon,
        iconAlt: "info",
        iconStyle: "width: 40px; height: 40px;",
        class: "info-icon"
      }, null, 8, ["iconContent"])])) : _createCommentVNode("", true)])])];
    }),
    _: 1
  }, 8, ["locale"]);
}